import * as Sentry from '@sentry/browser';
import React, { ReactNode, useState } from 'react';
import { useTranslation } from 'react-i18next';
import ErrorPage from '../layouts/ErrorPage';

type Props = {
  fallbackJsx?: ReactNode;
  children: ReactNode;
};

export default function ErrorBoundary({ fallbackJsx, children }: Props) {
  const { t } = useTranslation();
  const [hasError, setHasError] = useState(false);

  const componentDidCatch = (error: Error, errorInfo: React.ErrorInfo) => {
    Sentry.withScope(scope => {
      scope.setExtras(errorInfo);
      Sentry.captureException(error);
    });
    setHasError(true);
  };

  if (hasError) {
    return (
      fallbackJsx ?? (
        <ErrorPage title={t('ERROR_BOUNDARY__TITLE')}>{t('ERROR_BOUNDARY__TEXT')}</ErrorPage>
      )
    );
  }

  try {
    return <>{children}</>;
  } catch (error: any) {
    componentDidCatch(error, { componentStack: '' });

    return null;
  }
}
